import { createAsyncThunk } from "@reduxjs/toolkit"

import { errorSave } from "../../../redux/errors.slice"
import { handleGetResponseData } from "../../../utils/handlers/handle-get-response-data"
import { showResponseMessage } from "../../../utils/handlers/show-response-message.ts"
import * as services from "../services/phases.services"
import type {
  ProjectTypeAddPhaseParams,
  ProjectTypeCopyPhaseParams,
  ProjectTypeTemplatePhase
} from "../types/project-type.types.ts"

export const createPhaseForProjectType = createAsyncThunk<
  ProjectTypeTemplatePhase,
  ProjectTypeAddPhaseParams
>("projectTypes/createPhase", async (params, { dispatch, rejectWithValue }) => {
  const response = await services.createPhase(params)

  if (!response.ok) {
    dispatch(errorSave(response?.data?.details))
    return rejectWithValue(response.data)
  }

  showResponseMessage(response, "Phase created successfully.")
  return response.data?.details?.data as ProjectTypeTemplatePhase
})

export const deletePhaseForProjectType = createAsyncThunk<string, string>(
  "projectTypes/deletePhase",
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.deletePhase(id)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details))
      return rejectWithValue(response.data)
    }

    showResponseMessage(response, "Phase deleted successfully.")

    return id
  }
)

export const copyPhaseForProjectType = createAsyncThunk<
  ProjectTypeTemplatePhase[] | ProjectTypeTemplatePhase,
  ProjectTypeCopyPhaseParams
>("projectTypes/copyPhase", async (params, { dispatch, rejectWithValue }) => {
  const { id, name, project_type_id } = params
  const response = await services.copyPhase(id, {
    project_type_id,
    ...(name ? { name } : {})
  })

  if (!response.ok) {
    dispatch(errorSave(response?.data?.details))
    return rejectWithValue(response.data)
  }

  showResponseMessage(response, `Milestone copied successfully.`)

  return response.data?.details?.data as
    | ProjectTypeTemplatePhase[]
    | ProjectTypeTemplatePhase
})

export const partialUpdatePhase = createAsyncThunk(
  "projectTypes/partialUpdatePhase",
  async (params: any, { dispatch, rejectWithValue }) => {
    const response = await services.partialUpdatePhase(params)
    const data = handleGetResponseData(response)?.data

    if (!response.ok) {
      dispatch(errorSave(data))
      return rejectWithValue(data)
    }

    showResponseMessage(response, "Phase updated successfully.")

    return data?.data
  }
)
